<div class="modal-content border-0">
  <div class="modal-header bg-primary p-3">
    <h5 class="modal-title text-white">
      <i class="fas fa-envelope me-2"></i>Renvoyer l'email de vérification
    </h5>
    <button type="button" class="btn-close text-white" (click)="closeModal()"></button>
  </div>
  <form [formGroup]="resendForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <p class="text-muted">Entrez votre adresse email pour recevoir un nouveau lien de vérification.</p>
      <div class="mb-3">
        <label for="resendEmail" class="form-label">Adresse email</label>
        <input type="email" id="resendEmail" class="form-control" formControlName="email"
          placeholder="exemple@email.com"
          [class.is-invalid]="resendForm.get('email')?.invalid && resendForm.get('email')?.touched" />
        <div class="invalid-feedback" *ngIf="resendForm.get('email')?.invalid && resendForm.get('email')?.touched">
          Email invalide
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">Annuler</button>
      <button type="submit" class="btn btn-primary">
        {{loading? 'Veuillez patienter ' : 'Envoyer' }}
        <span class="{{ loading? 'spinner-border spinner-border-sm ms-2' : '' }}" role="status"> </span>
      </button>
    </div>
  </form>
</div>
